import Image from 'app/components/layouts/Image';
import { useTranslation } from 'next-i18next';
import env from '.env.json';

const WhyLearn = () => {
  const { t } = useTranslation();

  return (
    <div className="class-offer-area section-bg2 px-5" id="go-home">
      <div className="container-md">
        <div className="row justify-content-center pt-5">
          <div className="text-center mb-10">
            <div className="form-group mb-5">
              <h2 className="text-info text-size-3xl mb-1"><b>{t('home.why_learn')} {env.APP_NAME} ?</b></h2>
              <p className="text-size-xl"><b>{t('home.why_info')}</b></p>
            </div>
            <div className="row group-content mb-5 m-2">
              <div className='col-md-4 col-sm-12'>
                <Image width={100} className='mx-auto mb-3 mt-3' src="/images/commons/convenient.webp" alt={t('home.convenient')} />
              </div>
              <div className='col-md-8 col-sm-12'>
                <h2 className='text-info font-weight-bold mb-1'>{t('home.convenient')}</h2>
                <div className="content bold">{t('home.convenient_info')}</div>
              </div>
            </div>
            <div className="row group-content mb-5 m-2">
              <div className='col-md-4 col-sm-12'>
                <Image width={100} className='mx-auto mb-3 mt-3' src="/images/commons/easy.webp" alt={t('home.easy')} />
              </div>
              <div className='col-md-8 col-sm-12'>
                <h2 className='text-info font-weight-bold mb-1'>{t('home.easy')}</h2>
                <div className="content bold">{t('home.easy_info')}</div>
              </div>
            </div>
            <div className="row group-content mb-3 m-2">
              <div className='col-md-4 col-sm-12'>
                <Image width={100} className='mx-auto mb-3 mt-3' src="/images/commons/test.webp" alt={t('home.test')} />
              </div>
              <div className='col-md-8 col-sm-12'>
                <h2 className='text-info font-weight-bold mb-1'>{t('home.test')}</h2>
                <div className="content bold">{t('home.test_info')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WhyLearn;
